import { CheckboxField, ObjectField, TextField } from "~/components/Form";
import { NewLqsResourceForm, useCreateRole } from "~/lqs";
import { makeRoleLocation } from "~/paths";
import { createRoleSchema } from "../schemas";

export function RoleCreateForm() {
  return (
    <NewLqsResourceForm
      schema={createRoleSchema}
      defaultValues={{
        name: null,
        policy: null,
        note: null,
        _default: false,
        managed: false,
        disabled: false,
      }}
      resourceName="role"
      mutation={useCreateRole()}
      createDetailsLocation={(response) =>
        makeRoleLocation({ roleId: response.data.id })
      }
    >
      {(control) => (
        <>
          <TextField control={control} name="name" required />
          <ObjectField control={control} name="policy" required />
          <CheckboxField control={control} name="_default" />
          <CheckboxField control={control} name="managed" />
          <CheckboxField control={control} name="disabled" />
          <TextField control={control} name="note" />
        </>
      )}
    </NewLqsResourceForm>
  );
}
